import { apiPatch, apiPost } from "./apiClient";

// Same PATCH route, reused for 5 distinct field-edit purposes across two
// domains: inline part-field edits/disable/enable in WorkflowTaskDrawer, and
// quote-selection/selling-price edits in PriceUpdateDrawer. Each domain's
// own model layer wraps this primitive with its specific payload shape.
export function patchQueryPart(partId, fields) {
  return apiPatch(`/query-parts/${partId}`, fields).then(res => res.data);
}

export function addQueryPart(payload) {
  return apiPost("/query-parts", payload).then(res => res.data);
}
